<template>
    <div>
        <h4>圖卡位置設定</h4>
        <h5>
            <v-icon color="primary" >
                mdi-cellphone
            </v-icon>					
            手機原始圖卡位置
        </h5>
        <div class="input-container">
            <section class="field-container">
                <label>
                    <v-icon color="primary">
                        mdi-format-vertical-align-bottom
                    </v-icon>							
                    往下位移
                </label>
                <input 
                    @change="updateStatus('marketing_card','card_mobile_mg_top', card_mobile_mg_top)"
                    type="text" 
                    name=""
                    v-model="card_mobile_mg_top"
                    @input="updateStatus('marketing_card','card_mobile_mg_top', card_mobile_mg_top)"
                >
                <p class="field-message-container" style="margin: 0px;">							
                    <v-icon
                        v-if="origin_card_message === ''"
                        class="greenlight"
                        
                    >
                        mdi-check-circle-outline
                    </v-icon>
                    <v-icon 
                        v-if="origin_card_message !== ''"
                        class="redlight"
                        
                    >
                        mdi-alert-circle-outline
                    </v-icon>								
                    <span
                        :class="{
                            redlight: origin_card_message !== '',
                            greenlight: origin_card_message === ''
                        }"
                    >
                        {{ origin_card_message }}
                    </span>
                </p>
            </section>
        </div>
        <h5>
            <v-icon color="primary">
                mdi-cellphone
            </v-icon>
            手機縮小圖卡位置
        </h5>
        <div class="input-container">
            <section class="field-container">
                <label>
                    <v-icon color="primary">
                        mdi-format-vertical-align-bottom
                    </v-icon>								
                    往下位移								
                </label>
                <input 
                    @change="updateStatus('marketing_card','card_mobile_mini_mg_top', card_mobile_mini_mg_top)"
                    type="text" 
                    name=""
                    v-model="card_mobile_mini_mg_top"
                    @input="updateStatus('marketing_card','card_mobile_mini_mg_top', card_mobile_mini_mg_top)"
                >
                <p class="field-message-container" style="margin: 0px;">							
                    <v-icon
                        v-if="mini_card_message === ''"
                        class="greenlight"
                        
                    >
                        mdi-check-circle-outline
                    </v-icon>
                    <v-icon
                        v-if="mini_card_message !== ''"
                        class="redlight"
                    >
                        mdi-alert-circle-outline
                    </v-icon>								
                    <span
                        :class="{
                            redlight: mini_card_message !== '',
                            greenlight: mini_card_message === ''
                        }"
                    >
                        {{mini_card_message}}
                    </span>
                </p>							
            </section>
        </div>
        <h5>桌機原始圖卡位置</h5>
        <div class="input-container">
            <!-- <section class="field-container">
                <label>
                    <i class="material-icons-outlined">
                    vertical_align_top
                    </i>							
                    往上位移
                </label>
                <input 
                    type="text" 
                    name=""
                    v-model="card_desktop_mg_bottom"
                >
                <p class="field-message-container">							
                    <i 
                        v-if="desktop_card_bottom_message === ''"
                        class="material-icons-outlined greenlight"
                    >
                        check_circle_outline
                    </i>
                    <i 
                        v-if="desktop_card_bottom_message !== ''"
                        class="material-icons-outlined redlight">
                        error_outline
                    </i>								
                    <span
                        :class="{
                            redlight: desktop_card_bottom_message !== '',
                            greenlight:desktop_card_bottom_message === ''
                        }"
                    >
                        {{desktop_card_bottom_message}}
                    </span>
                </p>
            </section> -->
            <section class="field-container">
                <label>
                    <i 
                        class="material-icons-outlined"
                        style="transform: rotate(180deg)"
                    >
                    keyboard_tab
                    </i>								
                    往左位移
                </label>
                <input 
                    @change="updateStatus('marketing_card','card_desktop_mg_right', card_desktop_mg_right)"
                    type="text" 
                    name=""
                    v-model="card_desktop_mg_right"
                    @input="updateStatus('marketing_card','card_desktop_mg_right', card_desktop_mg_right)"
                >
                <p class="field-message-container mb-0">							
                    <i 
                        v-if="desktop_card_right_message === ''"
                        class="material-icons-outlined greenlight"
                    >
                        check_circle_outline
                    </i>
                    <i 
                        v-if="desktop_card_right_message !== ''"
                        class="material-icons-outlined redlight">
                        error_outline
                    </i>								
                    <span
                        :class="{
                            redlight: desktop_card_right_message !== '',
                            greenlight: desktop_card_right_message=== ''
                        }"
                    >
                        {{desktop_card_right_message}}
                    </span>
                </p>							
            </section>						
        </div>												
    </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        oldSettingData: Object,
        loadOldSettingData: Boolean,
        timeLineMode: String,
    },
    name: "MarketingCardSettingPosition",
    components: {

    },
    data(){
        return{
            /* 手機原始圖卡向下位移 */
            card_mobile_mg_top: '50',

            /* 手機縮小圖卡向下位移 */
            card_mobile_mini_mg_top: '50',

            card_desktop_mg_right: '0',

            desktop_card_right_message : '',

            /* 手機原始圖卡檢查錯誤訊息 */
      	    origin_card_message: '',

            /* 手機縮小圖卡檢查錯誤訊息 */
      	    mini_card_message:'',

            /* 監聽它來判斷是否需要載入舊設定檔，會從父組件傳值進來 */
            load_old_setting_data: false,

            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            }
        }
    },
    watch: {
        card_mobile_mg_top: function(newVal) {
    		console.log(this.checkIsInt(newVal))
    		let result = this.checkIsInt(newVal) 
    		if (result === false ) {
    			this.origin_card_message = '請填入數字'
    		}
    		else {
    			this.origin_card_message = ''
    		}
    	},
    	card_mobile_mini_mg_top: function(newVal) {
     		console.log(this.checkIsInt(newVal))
    		let result = this.checkIsInt(newVal) 
    		if (result === false ) {
    			this.mini_card_message = '請填入數字'
    		}
    		else {
    			this.mini_card_message = ''
    		}   		
    	},
    	card_desktop_mg_bottom: function(newVal) {
      		console.log(this.checkIsInt(newVal))
    		let result = this.checkIsInt(newVal) 
    		if (result === false ) {
    			this.desktop_card_bottom_message = '請填入數字'
    		}
    		else {
    			this.desktop_card_bottom_message = ''
    		}    		
    	},
    	card_desktop_mg_right: function(newVal) {
       		console.log(this.checkIsInt(newVal))
    		let result = this.checkIsInt(newVal) 
    		if (result === false ) {
    			this.desktop_card_right_message = '請填入數字'
    		}
    		else {
    			this.desktop_card_right_message = ''
    		}     		
    	},
        loadOldSettingData: {
            handler: function(newValue) {
                this.load_old_setting_data = newValue
            },
            immediate: true
        },
        load_old_setting_data: {
            handler: function(newValue) {
                if (newValue) {
                    console.log(this.oldSettingData);
                    console.log(this[this.parseKey[this.timeLineMode]]['mobile_card_margin']);
                    // alert(this[this.parseKey[this.timeLineMode]]['mobile_card_margin'])
                    console.log(this[this.parseKey[this.timeLineMode]]['mobile_mini_card_margin']);
                    this.card_mobile_mg_top = this.oldSettingData !== null
                                            ? this.oldSettingData['mobile_card_margin'].split('px')[0]
                                            : (this[this.parseKey[this.timeLineMode]]['mobile_card_margin']).split('px')[0]
                    this.card_mobile_mini_mg_top = this.oldSettingData !== null 
                                                ? this.oldSettingData['mobile_mini_card_margin'].split('px')[0]
                                                : (this[this.parseKey[this.timeLineMode]]['mobile_mini_card_margin']).split('px')[0]
                    
                    // this.discount_price_size = add_column['discount_price_size']
                    // this.discount_price_color = add_column['discount_price_color']
                    // this.discount_price = add_column['discount_price']
                    // this.product_text_size = add_column['product_text_size']
                    // this.product_text_color = add_column['product_text_color']
                    // this.product_text = add_column['product_text']
                }
            },
            immediate: true
        },
        timeLineMode: {
            handler: function(newValue) {
                console.log(newValue);
                this.card_mobile_mg_top = this.oldSettingData !== null
                                            ? this.oldSettingData['mobile_card_margin'].split('px')[0]
                                            : (this[this.parseKey[this.timeLineMode]]['mobile_card_margin']).split('px')[0]
                this.card_mobile_mini_mg_top = this.oldSettingData !== null 
                                                ? this.oldSettingData['mobile_mini_card_margin'].split('px')[0]
                                                : (this[this.parseKey[this.timeLineMode]]['mobile_mini_card_margin']).split('px')[0]

                if (this.oldSettingData) {
                    console.log('position load')
                }
                else {
                    console.log('position load_2', this[this.parseKey[this.timeLineMode]])
                    let margin_text = this[this.parseKey[this.timeLineMode]].desktop_card_margin.replace(/px/g, '')
                    let margins = margin_text.split(' ')
                    // 上右下左
                    this.card_desktop_mg_right = margins[1]
                }

            },
            // immediate: true
        }
    },
    computed: {
        ...mapState(['marketing_card',]),
        ...mapGetters(['warmUpCardSetting','activityCardSetting','endUpCardSetting'])
        // cardMobileMgTop: {
        //     get() {
        //         return this.card_mobile_mg_top
        //     },
        //     set(newValue) {
        //         this.card_mobile_mg_top = newValue
        //     }
        // },
        // originCardMessage(){
        //     const isInt = this.checkIsInt(this.card_mobile_mg_top)
        //     if (!isInt) {
        //         return '請填入數字'
        //     } else {
        //         return ''
        //     }
        // }
    },
    methods: {
        /**
		 * 2021-10-15 created by Watson 
		 *
		 * 說明: 用來檢查輸入的欄位是不是數字
		 *
		*/     	
    	checkIsInt: function(int_string) {

    		let tmpVal = parseInt(int_string).toString()

    		if (tmpVal === int_string) {
    			return true
    		}
    		else {
    			return false
    		}

    	},
        changeStatus: function(param_name,field_name, new_value){
            let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            tmp[field_name] = new_value
            this.$store.commit(param_name, tmp)
            console.log('after_commit', this.$store.getters[param_name])
        },
        async updateStatus(state, key, value) {
            await this.changeStatus(state, key, value)
            await this.$emit('save-time-line-setting')
            let keyMapper = {
                'card_mobile_mg_top': "mobile_card_margin",
                'card_mobile_mini_mg_top': "mobile_mini_card_margin",
                'card_desktop_mg_right': 'desktop_card_margin'
            }
            if (key === 'card_mobile_mg_top' || key === 'card_mobile_mini_mg_top') {
                this.syncCardSetting(keyMapper[key], `${value}px 0px 0px 0px`)
            }

            if (key === 'card_desktop_mg_right') {
                this.syncCardSetting(keyMapper[key], `0px ${value}px 10px 0px`)
            }
        },
        syncCardSetting(key, value) {
            this.$store.commit('update_warm_up_card_setting',{ [key] : value })
            this.$store.commit('update_activity_card_setting',{ [key] : value })
            this.$store.commit('update_end_up_card_setting',{ [key] : value })
        },
    }
}
</script>

<style scoped>
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }
    .preview-hint-container > h4{
        display: flex;
        align-items: center;
        margin-top: 0.5em;

    }
    .preview-hint-container > h4 > i {
        margin-right: 0.5em;
    }
    .preview-container, .setting-container {
        display: flex;
        flex-direction: column;
    }
    .setting-container {
        width: 100%;
        overflow: hidden;
    }
    .setting-main {
        overflow: scroll;
    }
    .setting-main > article{
        background-color: #FFFFFF;
        border-bottom:1px #CCC solid;
        padding: 1em;
        overflow: scroll;
    }
    .setting-main > article:last-child {
        border-bottom: none;
    }
    .setting-main > article > h4 {
        padding-bottom:1em;
        font-weight: 600;
        font-size: 1.4em;
    }
    .setting-main > article > h5 {
        padding-bottom:1em;
        font-weight:500;
        font-size: 1.1em;
        display: flex;
    }
    .setting-main > article > h5 > i {
        color: #409aff;
        margin-right: 0.5em;
    }

    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .basic-setting-title {	
        display: flex;
    }
    .basic-setting-title > span {
        display: flex;
        align-items: center;
        font-size: 0.7em;
        color: #409aff;
        margin-left: 0.5em;
    }
    .basic-setting-title > span > i{

        font-size: 18px;
        margin-right: 5px;

    }
    .basic-setting-title > span > a{

        font-weight: 200;
        outline: none;
        text-decoration: none;
        color: #409aff;

    }
    .basic-setting-title > span > a:hover {
        text-decoration: underline;
    }
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }

    .disable_margin {
        margin: 0px;
    }

    .label_active {
        color: #ea8181;
    }
    .field-container {
        position: relative;
    }
    .field-message-container {
        position: absolute;
        top: 0px;
        right: 10px;
        bottom: 0px;
        display: flex;
        font-size: 0.8em;
        align-items: center;
    }
    .greenlight {
        color: #3DCC9B;
    }
    .redlight {
        color: #f26e6e;
    }
    h4 {
        padding-bottom:1em;
        font-weight: 600;
        font-size: 1.4em;
    }
</style>